import { debounce } from "./debounce";

const filterPosts = debounce((event) => {
  const filter = event?.target?.value || "";
  const terms: string[] = filter.trim().split(" ");

  const maxItems = 7;
  let displayedItems = 0;

  document.querySelectorAll(".posts-table tbody tr").forEach((tr) => {
    const row = tr as HTMLElement;
    const text = row.querySelector("td:last-child")?.textContent?.trim() || "";

    if (displayedItems < maxItems && terms.every((term) => text.match(new RegExp(term, "gi")))) {
      displayedItems++;
      row.style.display = ""; // Show row
    } else {
      row.style.display = "none"; // Hide row
    }
  });
});

const filterElement = document.querySelector("#postsFilter") as HTMLElement;

if (filterElement) {
  filterPosts(null);
  filterElement.onkeyup = (event) => filterPosts(event);
}
